const CANCEL_EVENT_NAME = "ld_service.cancel";
const SUCCESS_EVENT_NAME = "ld_service.success";
const FAIL_EVENT_NAME = "ld_service.fail";

export class EventEmitter {
  static cancel(): void {
    this.postEvent(CANCEL_EVENT_NAME);
  }
  static success(verificationId: string): void {
    this.postEvent(SUCCESS_EVENT_NAME, { identityAccessKey: verificationId });
  }
  static fail(failCode: string | null, fullLogs: string | null): void {
    this.postEvent(FAIL_EVENT_NAME, { failCode, fullLogs });
  }
  static postEvent(eventName: string, args: any = null) {
    window.parent.postMessage({ eventName, args }, "*");
  }
}
